export enum DataState {
    None = 'none',
    Loading = 'loading',
    Error = 'error',
    NoData = 'noData'
}
